// extracted by mini-css-extract-plugin
export var active = "_fb-2";
export var recordingDot = "_fb-1";
export var recordingIndicator = "_fb-0";